export const INTEREST_LABELS: Record<string, string> = {
  franchise_terms: '가맹 조건 및 혜택',
  marketing: '마케팅 지원',
  content: '학습 콘텐츠와 교재',
  curriculum: '커리큘럼',
  class_method: '수업 방식',
  operation: '운영 시스템',
  other: '기타 (직접 입력)',
}

export const FRANCHISE_TYPE_LABELS: Record<string, string> = {
  academy: '학원',
  tutoring: '교습소',
}

export const SESSION_MODE_LABELS: Record<string, string> = {
  offline: '오프라인',
  online: '온라인',
}

export const SIDO_OPTIONS = [
  '서울', '부산', '대구', '인천', '광주', '대전', '울산', '세종',
  '경기', '강원', '충북', '충남', '전북', '전남', '경북', '경남', '제주',
] as const

export interface LabelResolution {
  text: string
  missing: boolean
}

export function labelOrRaw(map: Record<string, string>, raw: string): LabelResolution {
  const text = map[raw]
  return text ? { text, missing: false } : { text: raw, missing: true }
}
